import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from 'config/AxiosConfig'
import { useSelector } from 'react-redux';

const AuthService = () => {
  const { token } = useSelector((state: any) => state.auth);

  const getConfig = async (): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.get(
        '/v1/legacy/configApps/mobile',
        {
          headers: {
            ...axiosInstance.defaults.headers.common,
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message;
    }
  };

  return { getConfig };
};

export default AuthService;